/**
 * Gate 2 — paths without a schema.
 *
 * Flags Firestore path-registry rows whose `entityId` resolves to no entity.
 * A path with no owning schema is an undocumented collection.
 *
 * @see docs/impl/129-data-model-coverage-audit.html §21
 */
import type { AtlasManifest } from '../types.js';
import type { ValidationIssue } from './index.js';

/** Detect Firestore paths whose owning entity has no schema. */
export function pathWithoutSchema(manifest: AtlasManifest): ValidationIssue[] {
  const entityIds = new Set(manifest.entities.map((e) => e.id));
  const issues: ValidationIssue[] = [];
  for (const path of manifest.paths) {
    if (entityIds.has(path.entityId)) continue;
    issues.push({
      gate: 'path-without-schema',
      ref: path.path,
      message: `Firestore path "${path.path}" maps to entity "${path.entityId}" which has no schema.`,
    });
  }
  return issues;
}
